export default "__VITE_ASSET__db767e54__"